import * as React from 'react';
import * as _ from 'lodash';
import { DropdownButton, Glyphicon, MenuItem } from 'react-bootstrap';
import OverlayMenuButton from '@nkr/components/overlay-menu-button';
import { DonorShieldDirectViewType } from '@nkr/enums/index';
import { IDonorShieldDirect } from '@nkr/models/index';
import DonorShieldDirectAction from './action';

const menuItemList = [
    { action: DonorShieldDirectAction.Edit, title: <div>Edit</div> },
    { action: DonorShieldDirectAction.Delete, title: <div>Delete</div> },
    { action: DonorShieldDirectAction.ApplyforWage, title: <div>Apply for Donor Shield Reimbursement</div> },
    { action: DonorShieldDirectAction.OrderStreamlinedSerology, title: <div>Order Streamlined Serology Kit</div> },
    //{ action: DonorShieldDirectAction.EditWageAndTravel, title: <div>Edit Wage/Expense Info</div> } //MAY Re-add
];

interface IProps {
    request: IDonorShieldDirect,
    isNkrSuper: boolean,
    showBsMenu: boolean,
    updateModalView: (id: number, type: DonorShieldDirectViewType) => void,
    onMenuToggle: (show: boolean) => void,
    onItemSelected: (req: number, action: number) => void
}

class ActionsDropdown extends React.Component<IProps, {}> {
    isPopup = () => {
        return true;
    }

    getUrl = (action, requestId: number) => {
        switch (action) {
            case DonorShieldDirectAction.Edit: return { link: '/center/' + this.props.request.centerId + '/donors/donor-shield-direct/edit-donor/' + this.props.request.id };
            case DonorShieldDirectAction.ApplyforWage: return { link: '/center/' + this.props.request.centerId + '/donors/watr/add-request?donorShieldId=' + this.props.request.id };
        }
    }

    handleMenuToggle = (show: boolean) => {
        this.props.onMenuToggle(show);
    };

    handleMenuSelection = (id: number, action: number) => {
        this.props.onItemSelected(id, action);
    };

    renderBsStyle = () => {
        return (
            <>
                <DropdownButton id={`action-menu-${this.props.request}`} bsStyle="primary" bsSize='sm' title="Actions" block pullRight>
                    <MenuItem>Edit</MenuItem>
                    <MenuItem>Delete</MenuItem>
                    <MenuItem>Apply for Donor Shield Reimbursement</MenuItem>
                </DropdownButton>
            </>
        );
    }

    getMenuItems = () => {
        let menuItems: DonorShieldDirectAction[] = [];

        menuItems.push(DonorShieldDirectAction.Edit);
        menuItems.push(DonorShieldDirectAction.Delete);
        menuItems.push(DonorShieldDirectAction.ApplyforWage);

        if (!this.props.request.hasStreamlinedSerologyOrder) {
            menuItems.push(DonorShieldDirectAction.OrderStreamlinedSerology);
        }

        // if (this.props.request.watrRequest != null) {
        //     menuItems.push(DonorShieldDirectAction.EditWageAndTravel);
        // }

        return menuItems;
    }

    render = () => {
        if (this.props.showBsMenu) {
            return this.renderBsStyle();
        }

        let menuItems = this.getMenuItems().map(item => {
            return menuItemList.find(x => x.action == item);
        });

        let menu = menuItems.map(item => {
            let url = this.getUrl(item.action, this.props.request.id);
            let id = item.action >= 0 ? this.props.request.id : 'div-' + this.props.request.id + '-' + Math.random() * 10000;

            return { id, action: item.action, include: true, selectable: true, element: <>{item.title}</> };
        });

        return (
            <OverlayMenuButton
                menu={menu}
                bsStyle='primary'
                bsSize='xs'
                title='Actions'
                listItemStyle={{ padding: '2px 10px', fontSize: 14 }}
                includeCaret={true}
                onToggle={this.handleMenuToggle}
                onSelect={this.handleMenuSelection}
            />
        );
    }
}

export default ActionsDropdown;